import { useDuckQuery } from '../../../duckDB/hooks/useDuckQuery';
import { formattedDateColumn } from '../../../duckDB/utils/formattedDateColumn';

type ChartDateResult = {
  scanDate: string;
  displayDate: string;
};

/**
 * Hook that fetches the unique scan dates from the cluster report table
 * @param isTableLoading - whether the table is loading
 * @returns the unique scan dates and whether the query is loading
 */
export const useChartDates = (
  isTableLoading: boolean
): { chartDates: ChartDateResult[] | null; loading: boolean } => {
  const { data, isLoading } = useDuckQuery<ChartDateResult>(
    `
    SELECT DISTINCT ${formattedDateColumn('scan_date')} AS scanDate,
    ${formattedDateColumn('scan_date', '%B %d, %Y')} AS displayDate
    FROM cluster_report_table
    ORDER BY scan_date DESC
    `,
    isTableLoading
  );

  return { chartDates: data, loading: isLoading };
};
